'use client';

import { c as _c } from "react/compiler-runtime";
import type { AccommodationAvailableRoomsInput } from '@data-access/graphql/schema.types';
import { AccommodationAvailableRoomsDocument, type AccommodationAvailableRoomsQuery, type AccommodationAvailableRoomsQueryVariables } from '@data-access/lib/gql/accommodations/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { ACCOMMODATION_DETAIL_STALE_TIME, type AvailableRoom, selectAvailableRooms } from '../_lib/accommodation-detail-query';
const EMPTY_AVAILABLE_ROOMS_INPUT: AccommodationAvailableRoomsInput = {
  id: 0,
  checkin: '',
  checkout: '',
  allocation: []
};
export const useAppAvailableRooms = (input, options) => {
  const $ = _c(8);
  const t0 = input ?? EMPTY_AVAILABLE_ROOMS_INPUT;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      input: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!input;
  let t3;
  if ($[2] !== options || $[3] !== t2) {
    t3 = {
      ...options,
      select: _temp,
      enabled: t2,
      staleTime: ACCOMMODATION_DETAIL_STALE_TIME
    };
    $[2] = options;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const query = useGraphQL(AccommodationAvailableRoomsDocument, t1, t3);
  let t4;
  if ($[5] !== input || $[6] !== query) {
    t4 = {
      ...query,
      input
    };
    $[5] = input;
    $[6] = query;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(data) {
  return selectAvailableRooms(data) as AvailableRoom[];
}